import data from "../../../../../packages/react/src/CircleOcticon/CircleOcticon.docs.json";
import * as React from 'react';
export default {
  data,
  React
};